import React from 'react';

import Picker from 'emoji-picker-react';

interface EmojiPickerProps {
    preload?: boolean;
    onEmojiClick: (event: React.MouseEvent, data: any) => void;
}

const EmojiPicker: React.FC<React.PropsWithChildren<EmojiPickerProps>> = (
    props,
) => <Picker preload={props.preload} onEmojiClick={props.onEmojiClick} />;

export default React.memo(EmojiPicker);
